import onChange from 'on-change';

import api from './api';
import render from './render';

const buildUrl = (config) => {
  const { serviceName, elements, configRequest, dependence, isMember } = config;
  const { company, agent_email } = elements;
  const companyName = company?.textContent ?? null;
  const agentEmail = agent_email?.textContent ?? null;

  if (!company || companyName === '') {
    console.warn('No find company name.');
    return false;
  }

  if (isMember) {
    if (!agentEmail || agentEmail === '') {
      console.warn('No find agent email.');
      return false;
    }
  }

  const paramsEelents = elements[serviceName] ?? null;

  if (!paramsEelents) {
    console.warn(`No params for ${serviceName}`);
    return false;
  }

  if (dependence) {
    const keyParams = Object.keys(paramsEelents);
    const check = keyParams.every((item) => dependence.includes(item));

    if (!check) {
      console.warn('Parameters keys must be equals to dependence!');
      return false;
    }
  }

  const { base, args } = configRequest;
  const url = new URL(base);

  const params = Object.entries(paramsEelents).map(([name, element]) => {
    const elementContent = element?.textContent ?? null;
    if (!elementContent || elementContent === '') {
      console.warn(`Can't find data for: "${name}"!`);
      return null;
    }

    return [name, element.textContent];
  });

  if (params.includes(null)) {
    return false;
  }

  // set params to URL
  params.forEach(([name, value]) => {
    url.searchParams.set(`service[${serviceName}][${name}]`, value);
  });

  url.searchParams.set('company', companyName);
  // Object.entries(args).forEach(([key, value]) => url.searchParams.set(key, value));

  if (isMember) {
    url.searchParams.set('agent_email', agentEmail);
  }

  return url.href;
};

/* ---EXAMPLE--- */

// URLS

const app = async () => {
  const elements = {
    company: document.querySelector('[data-reviews="company"]'),
    agent_email: document.querySelector('[data-reviews="agent_email"]'),
    experience: {
      email: document.querySelector('[data-reviews="email"]'),
    },
    zillow: {
      zillow_nmls_id: document.querySelector('[data-reviews="zillow-nmls-id"]'),
      zillow_partner_id: document.querySelector(
        '[data-reviews="zillow-partner-id"]',
      ),
    },
    google: {
      place_id: document.querySelector('[data-reviews="place-id"]'),
    },
    maskMainSlide: document.querySelector('.reviews__slider-mask.w-slider-mask'),
  };

  const configRequest = {
    base: 'https://services.wowmi.us/api/web/api/v1/reviews',
    // args: {
    //   rate: 4,
    // },
  };

  const state = {
    reviews: null,
  };

  // ZILLOW
  const zillowUrlConf = {
    serviceName: 'zillow',
    elements,
    configRequest,
    dependence: ['zillow_partner_id', 'zillow_nmls_id'],
    isMember: false,
  };
  const zillowUrl = buildUrl(zillowUrlConf);

  // EXPERIENCE
  const experienceUrlConf = {
    serviceName: 'experience',
    elements,
    configRequest,
    dependence: null,
    isMember: true,
  };
  const experienceUrl = buildUrl(experienceUrlConf);

  // GOOGLE
  const googleUrlConf = {
    serviceName: 'google',
    elements,
    configRequest,
    dependence: null,
    isMember: true,
  };
  const googleUrl = buildUrl(googleUrlConf);

  const urls = [zillowUrl, experienceUrl, googleUrl].filter((url) => url);
  const watchedState = onChange(state, render(state, elements));

  const dataReviewsExperience = await api(experienceUrl);
  const dataReviewsZillow = await api(zillowUrl);
  const dataReviewsGoogle = await api(googleUrl);

  const totalReviews = [...dataReviewsExperience, ...dataReviewsZillow, ...dataReviewsGoogle];

  totalReviews.sort((a, b) => {
    if (a.date > b.date) {
      return -1;
    }
    if (a.date < b.date) {
      return 1;
    }
    return 0;
  });

  watchedState.reviews = totalReviews;
};

export default app;
